import 'magnific-popup'

function addressSearchMultiResultOpen() {
  $.magnificPopup.open(
    {
      items: [
        {
          src: '#addressSearchMultiResult',
          type: 'inline'
        }
      ],
      mainClass: 'p-whiteBackModal',
      closeOnBgClick: false,
      closeBtnInside: false,
      showCloseBtn: true,
      fixedContentPos: true,
      callbacks: {
        open() {
          const scrollpos = $(window).scrollTop()
          $('body').css('overflow', 'hidden')
          $('body').css('height', '100%')
          $('html').css('height', '100%')
          $('.l-container')
            .css({
              position: 'fixed',
              height: '100%',
              overflow: 'hidden',
              width: '100%',
              top: -scrollpos
            })
            .attr('data-top', scrollpos)
        },
        close() {
          $('body').css('overflow', 'auto')
          $('body').css('height', 'auto')
          $('html').css('height', 'auto')
          const returnpos = parseInt($('.l-container').attr('data-top'))
          $('.l-container').removeAttr('style')
          $(window).scrollTop(returnpos)
        }
      }
    },
    0
  )
}

$(function() {
  $(document).on(
    'click touchend',
    '.js-addressSearchMultiResultModalBtn',
    function() {
      addressSearchMultiResultOpen()
      return false
    }
  )

  $(document).on(
    'click touchend',
    '.js-addressSearchMultiResultModalClose',
    function(e) {
      e.preventDefault()
      $.magnificPopup.close()
    }
  )
})
